// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3ULpJ","select":"Header_select__Hd4be","clinic":"Header_clinic__3AHvu"};